module.exports = __webpack_public_path__ + "static/media/boot_clean_grid.2a0e9cfb.jpg";